import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(location);

  useEffect(() => {
    if (location.pathname !== currentLocation.pathname) {
      console.log('🔄 Starting page transition from', currentLocation.pathname, 'to', location.pathname);
      
      setIsTransitioning(true);
      setIsVisible(false);

      // Setelah fade out selesai, ganti konten
      const timer1 = setTimeout(() => {
        setCurrentLocation(location);
        setIsVisible(true);
        
        // Setelah fade in selesai, hentikan loading
        const timer2 = setTimeout(() => {
          setIsTransitioning(false);
          console.log('✅ Page transition complete');
        }, 400);

        return () => clearTimeout(timer2);
      }, 300);

      return () => clearTimeout(timer1);
    }
  }, [location.pathname, currentLocation.pathname]);

  // Set initial state
  useEffect(() => {
    setIsVisible(true);
    setIsTransitioning(false);
  }, []);

  return (
    <>
      {/* Loading Progress Bar */}
      {isTransitioning && (
        <div className="fixed top-0 left-0 right-0 z-[9999] h-1 bg-primary/80">
          <div className="h-full bg-white/60 animate-pulse" />
        </div>
      )}

      {/* Page Content */}
      <div
        className={`w-full min-h-full transition-opacity duration-300 ease-out ${
          isVisible ? "opacity-100" : "opacity-0"
        }`}
      >
        {children}
      </div>

      {/* Debug Panel (Development Only) */}
      {/* {process.env.NODE_ENV === 'development' && (
        <div className="fixed bottom-4 left-4 bg-black/80 text-white p-3 rounded-lg text-xs font-mono z-[9999]">
          <div>Current: {currentLocation.pathname}</div>
          <div>Target: {location.pathname}</div>
          <div>Visible: {isVisible.toString()}</div>
          <div>Transitioning: {isTransitioning.toString()}</div>
        </div>
      )} */}
    </>
  );
};

export default PageTransition;